import Layout from "@/components/layout/Layout";
import LiveTicker from "@/components/LiveTicker";
import HeroSection from "@/components/landing/HeroSection";
import ActivityTicker from "@/components/ActivityTicker";
import NewArrivals from "@/components/landing/NewArrivals";
import TrustSection from "@/components/landing/TrustSection";
import FeaturedProducts from "@/components/landing/FeaturedProducts";
import TopSellers from "@/components/landing/TopSellers";
import FeaturedServices from "@/components/landing/FeaturedServices";
import FeaturedCampaigns from "@/components/landing/FeaturedCampaigns";
import LogoMarquee from "@/components/landing/LogoMarquee";
import CTASection from "@/components/landing/CTASection";
import ChatBot from "@/components/ChatBot";
import { useSeo, SITE } from "@/hooks/useSeo";

const Index = () => {
  useSeo({
    title: "AAMECC | Africa–Asia–Middle East Digital Trade Chamber",
    description:
      "AAMECC is the investor-grade digital trade chamber connecting Africa, Asia and the Middle East. Verified members, escrow-protected trade, deal rooms and curated investment opportunities — built for serious commerce.",
    keywords:
      "AAMECC, Africa trade, Asia trade, Middle East chamber of commerce, digital trade, cross-border commerce, intercontinental investment, verified suppliers, deal room, ESG trade",
    canonical: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: SITE.name,
        url: SITE.url,
        logo: `${SITE.url}/logo/AAMECC%20ICON.png`,
        sameAs: ["https://twitter.com/AAMECC"],
        description:
          "Digital trade chamber connecting Africa, Asia and the Middle East with verified suppliers, escrow-protected transactions and curated investment opportunities.",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE.name,
        url: SITE.url,
        potentialAction: {
          "@type": "SearchAction",
          target: `${SITE.url}/marketplace?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
    ],
  });

  return (
    <Layout>
      <LiveTicker />
      <HeroSection />
      <NewArrivals />
      <TrustSection />
      <FeaturedProducts />
      <TopSellers />
      <FeaturedServices />
      <FeaturedCampaigns />
      <LogoMarquee />
      <CTASection />
      <ChatBot />
    </Layout>
  );
};

export default Index;
